<!-- BEGIN Loading bar -->
<ngx-loading-bar color="#275891"  [includeSpinner]="true" [height]="'3px'"></ngx-loading-bar>
<!-- END Loading bar -->

<router-outlet></router-outlet>

<!-- BEGIN Page Backdrop -->
<app-backdrop></app-backdrop>
<!-- END Page Backdrop -->
